"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiPrinterFill16 = {
    paths: [
        {
            path: 'M12.0046024,0 C12.5543453,0 13,0.443716645 13,0.999807492 L13,3 L14.9991283,3 C15.5518945,3 16,3.45303631 16,3.99703014 L16,10.0029699 C16,10.5536144 15.5553691,11 14.9991283,11 L13,11 L13,12.9970707 C13,13.5509732 12.5443356,14 12.0046024,14 L3.99539757,14 C3.44565467,14 3,13.5621186 3,12.9970707 L3,11 L1.00087166,11 C0.448105505,11 0,10.5469637 0,10.0029699 L0,3.99703014 C0,3.4463856 0.444630861,3 1.00087166,3 L3,3 L3,0.999807492 C3,0.447629061 3.4556644,0 3.99539757,0 L12.0046024,0 Z M11,9 L5,9 L5,12 L11,12 L11,9 Z M11,2 L5,2 L5,3 L11,3 L11,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Printer',
    width: 16,
    height: 14,
};
var muiPrinterFill24 = {
    paths: [
        {
            path: 'M18.9991283,0 C19.5518945,0 20,0.446311399 20,0.997544646 L20,4 L22.9993054,4 C23.5519738,4 24,4.45576096 24,5.00247329 L24,14.9975267 C24,15.5511774 23.5525308,16 22.9993054,16 L20,16 L20,19.0044225 C20,19.5542648 19.5553691,20 18.9991283,20 L5.00087166,20 C4.4481055,20 4,19.555163 4,19.0044225 L4,16 L1.00069463,16 C0.448026248,16 0,15.544239 0,14.9975267 L0,5.00247329 C0,4.44882258 0.44746922,4 1.00069463,4 L4,4 L4,0.997544646 C4,0.446615951 4.44463086,0 5.00087166,0 L18.9991283,0 Z M18,9 L6,9 L6,18 L18,18 L18,9 Z M16,14 L16,16 L8,16 L8,14 L16,14 Z M15,11 L15,13 L8,13 L8,11 L15,11 Z M21,6 C20.4477153,6 20,6.44771525 20,7 C20,7.55228475 20.4477153,8 21,8 C21.5522847,8 22,7.55228475 22,7 C22,6.44771525 21.5522847,6 21,6 Z M18,2 L6,2 L6,4 L18,4 L18,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Printer',
    width: 24,
    height: 20,
};
var muiPrinterFill = {
    base: muiPrinterFill16,
    smIcon: muiPrinterFill16,
    lgIcon: muiPrinterFill24,
};
exports.muiPrinterFill = muiPrinterFill;
//# sourceMappingURL=printerFill.js.map